import { WhiteLabelInfo } from "./../models/model";
import { Component, Input, OnInit } from "@angular/core";
import { LoadingService } from "../services/loading.service";
import { StorageService } from "../helpers/storage-Service";
import { DataService } from "src/app/pages/shared/data.service";
import { combineLatest, Observable, of } from "rxjs";
import { map } from "rxjs/operators";

@Component({
    selector: "app-loading",
    templateUrl: "./loading.component.html",
    styleUrls: ["./loading.component.scss"],
    standalone: false
})
export class LoadingComponent implements OnInit {
  //false renders the full screen backdrop, true an overlay sized to the
  //nearest positioned ancestor. exactly one instance is ever visible
  @Input() scoped = false;

  loading$ = this.loadingService.loading$;
  visible$: Observable<boolean>;
  whiteLabelInfo: WhiteLabelInfo;
  constructor(
    private loadingService: LoadingService,
    private storageService: StorageService,
    private dataService: DataService
  ) {
    this.dataService.emitWhiteLabelInfo.subscribe((val) => {
      if (val) {
        this.whiteLabelInfo = val;
      }
    });
  }

  ngOnInit(): void {
    this.visible$ = combineLatest([
      this.loadingService.loading$,
      this.loadingService.scoped$,
    ]).pipe(map(([loading, scoped]) => loading && scoped === this.scoped));

    const paymentInfo = this.storageService.getPaymentInfo();

    if (paymentInfo && paymentInfo.whiteLabelInfo !== null) {
      this.whiteLabelInfo = paymentInfo.whiteLabelInfo;
    }
  }
}
